import { render, staticRenderFns } from "./attachments-list-modal-detail.vue?vue&type=template&id=16f666ce&scoped=true&"
import script from "./attachments-list-modal-detail.ts?vue&type=script&lang=ts&"
export * from "./attachments-list-modal-detail.ts?vue&type=script&lang=ts&"
import style0 from "./attachments-list-modal-detail.scss?vue&type=style&index=0&id=16f666ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f666ce",
  null
  
)

export default component.exports